
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */
import PostLayout from "@src/layouts/PostLayout";
import LazyImage from "@src/components/LazyImage";
import InstaImage from "@src/components/InstaImage";
import ShopInfoBox from "@src/components/ShopInfoBox";
import { murakamiMasanori } from "@src/constants/authors";
import {
  ebisuChameFrontImage,
  ebisuChameLunchsetImage,
  ebisuChameLunchsoupImage,
} from "@src/constants/images";
export const meta = {
  path: "/media/ebisu/chame",
  title: "【恵比寿の行列店】韓国料理の「姉妹（チャメ）」で純豆腐がランチを食べよう",
  description: "恵比寿駅の人気の韓国料理店「姉妹（チャメ）」の純豆腐ランチについてご紹介します。土日のランチタイムには行列が必ずできる人気のお店の行列情報、さらには季節限定の純豆腐、他のお店とは違った辛さの選び方についてもご紹介します。恵比寿で韓国料理が食べたくなった場合は、ぜひお越しください。",
  topImg: ebisuChameLunchsoupImage,
  author: murakamiMasanori,
  tags: ["恵比寿", "有名店", "おしゃれな内装", "人気店", "お店の紹介", "韓国料理", "食べログ高評価"]
};

const layoutProps = {
  meta
};
const MDXLayout = ({ children }) => (
  <PostLayout meta={meta}>{children}</PostLayout>
)
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <p>{`「恵比寿で韓国料理店」と言われて思い浮かぶものはありますでしょうか。`}</p>
    <p>{`恵比寿の人気の韓国料理店「姉妹（チャメ）」の季節限定の純豆腐や、石釜で作るご飯、さらにはどの時間帯がランチだと並ばずに入れる狙い目かと行った情報を写真付きでご紹介させていただきます。`}</p>
    <p>{`恵比寿で韓国料理店でランチを食べることを考えている方にはオススメの記事になっております。`}</p>
    <h2>{`姉妹（チャメ）とは？`}</h2>
    <InstaImage postId="BznbqyLgfec" mdxType="InstaImage" />
    <p>{`恵比寿駅西口から徒歩 5 分の場所に位置する韓国料理店「姉妹（チャメ）」は、純豆腐が人気のお店として知られています。
食べログの評価は 3.57 と恵比寿エリアでは比較的高評価のお店で、多くの人が訪れ、ランチの時間帯は行列をなしています`}</p>
    <hr></hr>
    <h2>{`ランチメニュー`}</h2>
    <p>{`純豆腐が人気のお店ということもあ 10 種類近くの純豆腐ランチが取り揃えられております。
その他にも姉妹（チャメ）の特徴ともいえる石窯のご飯をご紹介させていただきます。`}</p>
    <h3>{`季節の純豆腐`}</h3>
    <LazyImage img={ebisuChameLunchsoupImage} mdxType="LazyImage" />
    <p>{`姉妹（チャメ）では季節に合わせた純豆腐ランチのメニューが提供されます。
こちらは冬の時期に限定して提供されるメニューで、「牡蠣純豆腐ランチ」。`}</p>
    <p>{`牡蠣の風味が染み込んだ出汁に、たっぷりと牡蠣が入った純豆腐は、他のお店ではなかなか体感できない味わいになっています。`}</p>
    <h3>{`定番の人気メニュー「海鮮純豆腐」`}</h3>
    <LazyImage img={ebisuChameLunchsetImage} mdxType="LazyImage" />
    <p>{`店内でも注文の声を多く聞く機会がある海鮮純豆腐は、姉妹（チャメ）の人気メニューです。
たら、海老、あさりなど多数の魚介を使用した出汁はさっぱりとして奥行きのある味わい。`}</p>
    <h3>{`選べる３つの辛さ`}</h3>
    <InstaImage postId="CGezTPXgwmq" mdxType="InstaImage" />
    <p>{`姉妹（チャメ）では全ての純豆腐の辛さをお好みで選ぶことができます。
その辛さも具体的な表現「辛いのが苦手な方」などで書いてあるため、初めて行った方でもわかりやすい表現になっています。
個人的には辛いのは得意な方ではないですが、２辛でピリ辛という程度でした！`}</p>
    <hr></hr>
    <h2>{`行列情報`}</h2>
    <p>{`恵比寿で韓国料理といえば「姉妹」しか人気店がなく、また駅から徒歩５分ほどのアクセスにあるため、多くの人が訪れます。
さらに店内の席数が約３０席程度しかないため、ランチの時間帯はすぐに埋まってしまうのが行列を作る理由となっております。`}</p>
    <h3>{`オープン前から行列`}</h3>
    <LazyImage img={ebisuChameFrontImage} mdxType="LazyImage" />
    <p>{`11:30 からランチをオープンする同店ですが、11:15 頃からすでに行列ができています。
オープン前だと人数が並んでいてもオープン時点だと比較的すぐに入れることが多いので、安心してお越しいただければと思います。`}</p>
    <h3>{`狙い目の時間帯はここ`}</h3>
    <p>{`13 時頃になっても行列ができているので、お越しの時間帯は狙い目を定めていかないとランチの時間帯で長時間待たないといけないことになります。
並ばずに入れる狙い目の時間帯は、オープン前の時間帯、あるいは 13 時 30 分頃です。
行列の流れがひと段落する時間帯で、この時間帯が一番並ばずに入れるポイントになっております。`}</p>
    <h3>{`平均待ち時間`}</h3>
    <p>{`とはいっても遅めのランチは苦手という方もいらっしゃると思いますので、ランチの平均待ち時間をお伝えします。
ピークの時間帯で 10 人程度並んでいる時で、約 20 分を目安に待っていただければと思います。
並んでいる時から注文を取ってくれるので、入店後は比較的早く食事にありつけると思います。`}</p>
    <hr></hr>
    <h3>{`おわりに`}</h3>
    <p>{`恵比寿の人気韓国料理店「姉妹（チャメ）」についてご紹介しましたが、いかがでしたか？行列情報をチェックいただき、季節に合わせた美味しい純豆腐ランチを楽しんでください。`}</p>
    <ShopInfoBox shopId="bulvfeq23akg00acjedg" mdxType="ShopInfoBox" />

    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;